
import axios from 'axios';

const apiClient = axios.create({
  baseURL: 'https://stm-dev.intentio.co.za/api/portal/', 
  headers: {
    'Content-Type': 'application/json',
    'x-portal-tenant-host': 'ftthsa',
  },
});

// Attach token dynamically before each request
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default apiClient;
